import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';

@Component({
  selector: 'app-contract-letter',
  templateUrl: './contract-letter.component.html',
  styleUrls: ['./contract-letter.component.css']
})
export class ContractLetterComponent implements OnInit {



  branchList;
  selectedBranch = [];
  isBranchSelected;
  reportingPartnerList;
  selectedReportingPartner;
  employeeList;
  selectedEmployeeName;
  constructor(private masterDataService: MasterDataService, private commonMessageService: CommonMessageService,
    private OrganizationSetupService: OrganizationSetupService,
  ) { }

  ngOnInit(): void {
    this.selectedEmployeeName = "";
    this.loadBranchList();
  }


  onBranchSelected() {
    var branchId = this.selectedBranch.map(({ id }) => id);
    // this.masterDataService.getEmployeeByBranch("1", branchId).subscribe((res: any) => {
    //   console.log('employee list', this.employeeList);
    //   this.employeeList = res;
    // })
    this.loadAssignedPartnerForBranch(branchId);
  }

  branchSelect(event) {
    // console.log(event);
    this.selectedBranch = event;
    this.isBranchSelected = true;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected);
    this.isBranchSelected = !this.isBranchSelected;
    // this.onBranchSelected();
  }

  loadAssignedPartnerForBranch(branch) {
    if (branch.length > 0) {
      this.masterDataService
        .getUserPartnersOfBranch(branch)
        .subscribe((res) => {
          console.log('select partner', res);
          this.reportingPartnerList = res;
        });
    } else {
      return;
    }
  }

  loadBranchList() {
    this.masterDataService.getBranch().subscribe((res) => {
      this.branchList = res;
    });
    console.log('branchList', this.branchList);
  }

  onPartnerSelected() {
    this.masterDataService.usersByReportingPartner(this.selectedReportingPartner.id).subscribe((res: any) => {
      console.log('employee list', res);
      this.employeeList = [...res].sort((a, b) =>
        a.firstName.localeCompare(b.firstName)
      );
    })
  }

  ExportLetter() {


    if (this.selectedEmployeeName == undefined || this.selectedEmployeeName == null || this.selectedEmployeeName == "" || this.selectedBranch == null) {
      this.commonMessageService.swalAlertWithoutIcon('', "Please select all filters.");
      return;
    }
    // Call the exportCommitmentLetter API with the selected article ID
    // this.masterDataService.exportContractLetter(this.selectedEmployeeName.id).subscribe({
    //   next: (res) => {
    //     console.log('export report', res);
    //   },
    //   error: (err) => {
    //     console.error('Error generating letter', err);
    //     // Handle error as necessary, e.g., display an error message to the user
    //   },
    //   complete: () => {
    //     // Show success alert upon successful export
    //     this.commonMessageService.swalAlertWithIcon('', 'Generated Successfully!', 'success');
    //   }
    // });
    const fullName = [
      this.selectedEmployeeName.firstName,
      this.selectedEmployeeName.middleName,
      this.selectedEmployeeName.lastName
    ]
      .filter(Boolean)
      .join('_');

    this.masterDataService
      .exportContractLetter(this.selectedEmployeeName.id)
      .subscribe({
        next: (res: Blob) => {

          const blob = new Blob([res], { type: 'application/pdf' });

          const downloadURL = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = 'ContractLetter_' + fullName + '.pdf';

          link.click();

          window.URL.revokeObjectURL(downloadURL);

          console.log('PDF downloaded successfully');
        },

        error: (err) => {
          console.error('Error generating letter', err);
        },

        complete: () => {
          this.commonMessageService.swalAlertWithIcon(
            '',
            'Generated Successfully!',
            'success'
          );
        }
      });
  }

}
